/*
  상수 처럼 쓰이는 변수 여기로 빼기
*/

// export const ORDER_ICON = {
//   'unset': 'indeterminate_check_box',
//   'descending': 'arrow_drop_down',
//   'ascending': 'arrow_drop_up'
// }

// export const DEFAULT_ORDER_ICON = {
//   true: 'check_box',
//   false: 'check_box_outline_blank'
// }

// 필터 차수 3차 -> 2차 -> 1차
export const DEFAULT_SORT_ORDER_LICENSED_ALL = [
  { value: 'category', type: 'category' },
  { value: 'licensee__order', type: 'licensee' },
  { value: '-created_at', type: 'created_at' },
  { value: 'priority', type: 'priority' }
]

export const DEFAULT_SORT_ORDER_LICENSED_CATEGORY = [
  { value: 'licensee__order', type: 'licensee' },
  { value: '-created_at', type: 'created_at' },
  { value: 'priority', type: 'priority' }
]

export const DEFAULT_SORT_ORDER_PINKFONG_ALL = [
  { value: '-price', type: 'price' },
  { value: 'category', type: 'category' },
  { value: '-created_at', type: 'created_at' }
]

export const DEFAULT_SORT_ORDER_PINKFONG_CATEGORY = [
  { value: '-price', type: 'price' },
  { value: '-created_at', type: 'created_at' }
]

export const PINKFONG_ORDER_OPTIONS = [
  { name: 'filter.release', value: '-created_at', type: 'created_at', default: true },
  { name: 'filter.priceHigh', value: '-price', type: 'price' },
  { name: 'filter.priceLow', value: 'price', type: 'price' }
]

export const LICENSED_ORDER_OPTIONS = [
  { name: 'filter.priority', value: 'priority', type: 'priority', default: true },
  { name: 'filter.release', value: '-created_at', type: 'created_at' },
  { name: 'filter.priceHigh', value: '-price', type: 'price' },
  { name: 'filter.priceLow', value: 'price', type: 'price' }
]

// 필터 창 아이콘
export const DROPDOWN_ICON = {
  true: 'expand_less',
  false: 'expand_more'
}

export const DROPDOWN_ICON_COLOR = {
  true: 'white',
  false: 'white'
}



// WEBPACK FOOTER //
// ./src/constants.js